module.exports = __webpack_public_path__ + "img/record-stats-icon.59e3673d.svg";